import axios from "axios";
import { useEffect, useState } from "react";
import "./App.css";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import ScrollToTop from "./Components/ScrollToTop";
import WindowScrollTop from "./Components/WindowScrollTop";
import RoutePage from "./Pages/RoutePage";

function App() {
  const [schoolInfo, setSchoolInfo] = useState([]);
  useEffect(() => {
    axios.get("JSON/schoolInfo.json").then((response) => {
      setSchoolInfo(response.data);
    });
  }, []);
  return (
    <>
      <Header schoolInfo={schoolInfo} />
      <RoutePage schoolInfo={schoolInfo} />
      <ScrollToTop />
      <Footer schoolInfo={schoolInfo} />
      <WindowScrollTop />
    </>
  );
}

export default App;
